module.exports = __webpack_public_path__ + "img/headportrait_2_icon.804d8823.png";